import axios, { type AxiosInstance } from 'axios'
import packageConfig from '@package'
import { serializeParamsLikeAxios0 } from './legacy-params-serializer'

/*
 * 중앙 API axios 인스턴스.
 *
 * - 재시도는 여기서 하지 않는다 — 쿼리 레이어(TanStack Query)의 retry가 담당한다.
 * - 인증 토큰은 Vuex 등 상태관리에 직접 의존하지 않고, 앱 부트스트랩 시점에
 *   주입받는 provider 로 조회한다 (React 전환 시 provider 교체만으로 재사용).
 */

type TokenProvider = () => string | null | undefined

const getHost = () => {
  const isLocal = process.env.AFTERDOC_LOCAL === 'true'

  if (isLocal) {
    const port = process.env.AFTERDOC_API_PORT || '8080'
    return process.env.VUE_APP_LOCAL_BACKEND_URL || `http://localhost:${port}`;
  }

  return packageConfig.isDevelopment ? 'https://dev.api.afterdoc.net' : 'https://api.afterdoc.net';
}

// main.js에서 부트스트랩 시점에 주입받는 provider. 
// setAuthTokenProvider() 로 설정
let tokenProvider: TokenProvider = () => null

export const setAuthTokenProvider = (provider: TokenProvider): void => {
  tokenProvider = provider
}

export const axiosInstance: AxiosInstance = axios.create({
  baseURL: getHost(),
  timeout: 30000,
  // v2 레거시 서버는 중첩 객체 파라미터를 JSON 문자열로 기대 — axios 0.x 직렬화 유지 필수
  paramsSerializer: { serialize: serializeParamsLikeAxios0 },
})

axiosInstance.interceptors.request.use(config => {
  const token = tokenProvider()
  if (token) {
    config.headers = config.headers ?? {}
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})
